import { productsAndServicesApi } from 'api';

export const checkCompatibility = async (accountNumber: string) => {
  return await productsAndServicesApi.createMandate({ accountNumber });
};
